import React from "react";

const CreateWorkOutCategoryCategories = React.lazy(() =>
  import("./CreateWorkOutCategories")
);
const Index = React.lazy(() => import("./index"));
const WorkoutCategories = React.lazy(() =>
  import("../../components/WorkoutCategories")
);

export const workoutCategoriesRoutes = [
  {
    path: "/admin/workOutCategory",
    name: "All Workout Category",
    element: <WorkoutCategories />,
  },
  {
    path: "/admin/workOutCategory/create",
    name: "Create workout Category",
    element: <CreateWorkOutCategoryCategories />,
  },
  {
    path: "/admin/workOutCategory/update/:id?",
    name: "Create workout Category",
    element: <CreateWorkOutCategoryCategories />,
  },
];
